import React, { useEffect } from 'react';

import request from '../../../utils/request';
import { LOAD_CACHE_LOGIN_URL } from '../../../utils/api';

const CreateCacheLogin = () => {
  const loadCachelogin = () => {
    const hasCache = sessionStorage.getItem('cacheLoginLoaded');

    if (!hasCache) {
      request(LOAD_CACHE_LOGIN_URL);
      sessionStorage.setItem('cacheLoginLoaded', true);
    }
  };

  useEffect(() => {
    loadCachelogin();
  });

  return (
    <div />
  );
};

export default CreateCacheLogin;
